import { BranchesTab } from '../components/BranchesTab';

export function BranchesSection() {
  return <BranchesTab />;
}
